export default __webpack_public_path__ + "static/media/register-failure.df8eddf6.svg";